import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FirstNotification, NotificationTitle } from "./subcomponents";
var NotificationFront = function (_a) {
    var notificationList = _a.notificationList, handleOnClick = _a.handleOnClick;
    var _b = notificationList[0], notificationType = _b.notificationType, notificationIcon = _b.notificationIcon, description = _b.description, subDescription = _b.subDescription;
    return (_jsx(FirstNotification, { onClickHandler: handleOnClick, type: notificationType, icon: _jsx(FontAwesomeIcon, { icon: ["far", notificationIcon] }), title: _jsx(NotificationTitle, { children: description }), subTitle: subDescription, dataType: "Flip card" }));
};
export default NotificationFront;
//# sourceMappingURL=index.js.map